// Shared option lists / label maps for the Property Scan (repaint-decision) workflow.
// Kept in one place so the New Scan form and the Report page's edit mode always
// agree on the same value/label pairs.

export function labelize(value?: string | null): string {
  if (!value) return '—';
  return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export const SURFACE_TYPE_OPTIONS = [
  'stucco', 'wood', 'brick', 'vinyl', 'fiber_cement', 'metal_siding', 'concrete',
].map((value) => ({ value, label: labelize(value) }));

export const COATING_OPTIONS = [
  'acrylic_latex', 'oil_based', 'elastomeric', 'unknown',
].map((value) => ({ value, label: labelize(value) }));

export const CONDITION_OPTIONS = [
  'excellent', 'good', 'fair', 'poor',
].map((value) => ({ value, label: labelize(value) }));

export const EXPOSURE_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'moderate', label: 'Moderate' },
  { value: 'high_uv', label: 'High UV' },
];

export const CONDITION_SCORE_COLOR = (score?: number | null): string => {
  if (score == null) return '#00AAFF';
  if (score >= 75) return '#4ADE80';
  if (score >= 40) return '#D97706';
  return '#EF4444';
};
